import { useState } from 'react';
import { getErrorMessage } from '@/shared/lib/api/errors';
import { assistenteService, type AnexoMia } from './assistenteService';

export const MAX_ANEXOS_MIA = 4;
const TAMANHO_MAX = 10 * 1024 * 1024;

function aceito(arquivo: File): boolean {
  return arquivo.type.startsWith('image/') || arquivo.type === 'application/pdf';
}

/**
 * Fotos e PDFs do compositor da Mia (R22): sobem na hora (anexo de publicacao) e vao com a
 * proxima fala. Ate 4 por fala, 10 MB cada.
 */
export function useAnexosMia(onErro: (mensagem: string | null) => void) {
  const [anexos, setAnexos] = useState<AnexoMia[]>([]);
  const [subindo, setSubindo] = useState(0);

  async function adicionar(arquivos: File[]) {
    onErro(null);
    const validos = arquivos.filter(aceito);
    if (validos.length < arquivos.length) onErro('A Mia lê só foto ou PDF.');
    const livres = MAX_ANEXOS_MIA - anexos.length - subindo;
    if (validos.length > livres) onErro(`Mande até ${MAX_ANEXOS_MIA} anexos por vez.`);
    for (const arquivo of validos.slice(0, Math.max(0, livres))) {
      if (arquivo.size > TAMANHO_MAX) {
        onErro(`${arquivo.name} passa de 10 MB.`);
        continue;
      }
      setSubindo((n) => n + 1);
      try {
        const anexo = await assistenteService.enviarAnexo(arquivo);
        setAnexos((atual) => [...atual, anexo]);
      } catch (error) {
        onErro(getErrorMessage(error, 'Nao foi possivel enviar o anexo.'));
      } finally {
        setSubindo((n) => n - 1);
      }
    }
  }

  function remover(idArquivo: number) {
    setAnexos((atual) => atual.filter((anexo) => anexo.idArquivo !== idArquivo));
  }

  /** Entrega os anexos para a fala e limpa o compositor. */
  function retirar(): AnexoMia[] {
    const atuais = anexos;
    setAnexos([]);
    return atuais;
  }

  return { anexos, subindo: subindo > 0, adicionar, remover, retirar };
}
